<template>
	<div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">

    <div>
      <!--<header1></header1>-->
      <sidebar class="sidebar-container"></sidebar>
      <div class="main-container">

        <navbar></navbar>
        <app-main></app-main>
      </div>

    </div>

	</div>
</template>

<script>
  import { Navbar, Sidebar, AppMain,Header1 } from '@/views/layout';

  export default {
    name: 'layout',
    components: {
      Navbar,
      Sidebar,
      AppMain,
      Header1
    },
    computed: {
      sidebar() {
        return this.$store.state.app.sidebar;
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@import "src/styles/mixin.scss";
	.app-wrapper {
		@include clearfix;
		position: relative;
		height: 100%;
		width: 100%;
		&.hideSidebar {
			.sidebar-container{
				width:36px;
				overflow: inherit;
			}
			.main-container {
				margin-left: 36px;
			}
		}
    .header{
      height: 10px;
    }
		.sidebar-container {
			transition: width 0.28s ease-out;
			width: 260px;
			height: 100%;
			position: fixed;
			top: 0;
			bottom: 0;
     // padding-top: 55px;
			left: 0;
			z-index: 1001;
			overflow-y: auto;
 			&::-webkit-scrollbar {display:none}
		}
		.main-container {
			min-height: 100%;
			transition: margin-left 0.28s ease-out;
			margin-left: 260px;
		}
	}
</style>



// WEBPACK FOOTER //
// Layout.vue?5e2fa018